module.exports = __webpack_public_path__ + "static/media/destination_pin.acf0e4c3.png";